import { Document, Packer, Paragraph, TextRun, AlignmentType, } from "docx";
import { saveAs } from "file-saver";
import { marked } from "marked";
import htmlDocx from 'html-docx-js/dist/html-docx';


// import "core-js/features/promise";
// import "core-js/features/array/from";



function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}${month}${day}`;
}

export const saveDocxArray = (fileName, message) => {
    // 将HTML内容转换为docx库可以识别的格式
    const convertedContent = message.join("").replace(/-/g, " -- ").replace(/"/g, "");;
    // const convertedContent = message.join("");

    const renderer = new marked.Renderer();
    renderer.paragraphs = [];

    const currentDate = new Date();
    const strDate = formatDate(currentDate);

    renderer.heading = (text, level) => {
        const paragraph = new Paragraph({
            text: text,
            heading: `Heading${level}`,
        });
        renderer.paragraphs.push(paragraph);
        return "";
    };

    renderer.paragraph = (text) => {
        const textArray = text.split(/[\r\n]+/).map((str) => str.replace(/&nbsp;/g, " "));
        const isUnorderedList = /^-\s/.test(textArray[0]);
        const children = textArray.map((str, index) => {
          return new TextRun({
            text: str.replace(/<w:br\/>/g, "\n"),
            break: index < textArray.length - 1,
          });
        });
        const paragraph = new Paragraph({
          children: children,
          alignment: AlignmentType.LEFT,
          bullet: isUnorderedList ? { level: 0 } : undefined,
        });
        renderer.paragraphs.push(paragraph);
        return "";
    };

    // 使用自定义的 marked 渲染器将 Markdown 转换为 doc 库的 Paragraph 对象数组
    marked(convertedContent, { renderer: renderer });
    const paragraphs = renderer.paragraphs;

    // 创建一个新的 doc 文档
    const doc = new Document({
        sections: [
        {
            properties: {},
            children: paragraphs,
        },
        ],
    });

    // 将文档转换为 Blob
    Packer.toBlob(doc).then((blob) => {
        // 使用 file-saver 保存 Blob 为 Word 文档
        saveAs(blob, `${fileName}_${strDate}.doc`);
    });
};

export const saveDocxbyHTML = async (fileName, message) => {
    console.log(message);

    const currentDate = new Date();
    const strDate = formatDate(currentDate);

    // 将 HTML 内容转换为 Word 文档
    const doc = htmlDocx.asBlob(`<html><body>${message}</body></html>`);  
    saveAs(doc, `${fileName}_${strDate}.docx`);
};